// extracted by mini-css-extract-plugin
module.exports = {"sun":"Sun_sun__12Lnp","sun60":"Sun_sun60__1zGMR","sun90":"Sun_sun90__GGPna"};